import { Suspense, lazy, useMemo } from 'react';
import OnboardingTourErrorBoundary from './OnboardingTourErrorBoundary';
import { getTourIdFromQueryParams } from '../util/urlUtils';
import { getLinkedTourId } from '../util/linkedTourUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingTourContainer = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "onboarding-tours" */'./internal/OnboardingTourContainer'));
const OnboardingTour = props => {
  const tourIdToUse = useMemo(() => props.tourId || getTourIdFromQueryParams() || getLinkedTourId(), [props.tourId]);
  if (!tourIdToUse) {
    return null;
  }
  return /*#__PURE__*/_jsx(OnboardingTourErrorBoundary, {
    tourId: tourIdToUse,
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(OnboardingTourContainer, Object.assign({}, props))
    })
  });
};
export default OnboardingTour;